import { ComponentCategory, ComponentOption } from "@/types/types";

const baseCpus: Omit<ComponentOption, 'socketType' | 'modelPath' | 'scale'>[] = [
  {
    id: "cpu-1",
    name: "Intel Core i5-13600K",
    brand: "Intel",
    price: 280,
    wattage: 125,
    amazonLink: "#",
    specs: {
      cores: "14 (6P+8E)",
      threads: "20",
      baseFrequency: "3.5 GHz",
      boostFrequency: "5.1 GHz",
      cache: "24MB",
      tdp: "125W",
      socket: "LGA 1700",
      memoryType: "DDR5",
      stockCooler: "No"
    },
    imageUrl: ""
  },
  {
    id: "cpu-2",
    name: "Intel Core i7-13700K",
    brand: "Intel",
    price: 360,
    amazonLink: "#",
    specs: {
      cores: "16 (8P+8E)",
      threads: "24",
      baseFrequency: "3.4 GHz",
      boostFrequency: "5.4 GHz",
      cache: "30MB",
      socket: "LGA 1700",
      memoryType: "DDR5",
      stockCooler: "No"
    },
    imageUrl: ""
  },
  {
    id: "cpu-3",
    name: "Intel Core i9-13900KF",
    brand: "Intel",
    price: 410,
    amazonLink: "#",
    specs: {
      cores: "24 (8P+16E)",
      threads: "32",
      baseFrequency: "3.0 GHz",
      boostFrequency: "5.8 GHz",
      cache: "36MB",
      socket: "LGA 1700",
      memoryType: "DDR5",
      stockCooler: "No"
    },
    imageUrl: ""
  },
  {
    id: "cpu-4",
    name: "AMD Ryzen 5 7600X",
    brand: "AMD",
    price: 180,
    amazonLink: "https://amzn.to/4cRYOZF",
    specs: {
      cores: "6",
      threads: "12",
      baseFrequency: "4.7 GHz",
      boostFrequency: "5.3 GHz",
      cache: "38MB",
      socket: "AM5",
      memoryType: "DDR5",
      stockCooler: "No"
    },
    imageUrl: ""
  },
  {
    id: "cpu-5",
    name: "AMD Ryzen 7 7800X3D",
    brand: "AMD",
    price: 370,
    amazonLink: "https://amzn.to/44IoKEW",
    specs: {
      cores: "8",
      threads: "16",
      baseFrequency: "4.2 GHz",
      boostFrequency: "5.0 GHz",
      cache: "96MB",
      socket: "AM5",
      memoryType: "DDR5",
      stockCooler: "No"
    },
    imageUrl: ""
  },
  {
    id: "cpu-6",
    name: "AMD Ryzen 9 7950X",
    brand: "AMD",
    price: 500,
    amazonLink: "https://amzn.to/4cT2gDk",
    specs: {
      cores: "16",
      threads: "32",
      baseFrequency: "4.5 GHz",
      boostFrequency: "5.7 GHz",
      cache: "80MB",
      socket: "AM5",
      memoryType: "DDR5",
      stockCooler: "No"
    },
    imageUrl: ""
  },
  {
    id: "cpu-7",
    name: "AMD Ryzen 5 5500",
    brand: "AMD",
    price: 75,
    amazonLink: "https://amzn.to/3RwN8lh",
    specs: {
      cores: "6",
      threads: "12",
      baseFrequency: "4.2 GHz",
      boostFrequency: "4.6 GHz",
      cache: "18MB",
      socket: "AM4",
      memoryType: "DDR4",
      stockCooler: "Yes - Wraith Stealth"
    },
    imageUrl: ""
  },
  {
    id: "cpu-8",
    name: "AMD Ryzen 5 5700X",
    brand: "AMD",
    price: 170,
    amazonLink: "https://amzn.to/445bI4b",
    specs: {
      cores: "8",
      threads: "16",
      baseFrequency: "4.2 GHz",
      boostFrequency: "4.6 GHz",
      cache: "18MB",
      socket: "AM4",
      memoryType: "DDR4",
      stockCooler: "Yes - Wraith Stealth"
    },
    imageUrl: ""
  },
  {
    id: "cpu-9",
    name: "AMD Ryzen 7 9800X3D",
    brand: "AMD",
    price: 480,
    amazonLink: "https://amzn.to/3S3XCsu",
    specs: {
      cores: "8",
      threads: "16",
      baseFrequency: "4.7 GHz",
      boostFrequency: "5.2 GHz",
      cache: "96MB",
      socket: "AM5",
      memoryType: "DDR5",
      stockCooler: "No"
    },
    imageUrl: ""
  },
  {
    id: "cpu-10",
    name: "AMD Ryzen 7 7700X",
    brand: "AMD",
    price: 250,
    amazonLink: "https://amzn.to/4jCA36a",
    specs: {
      cores: "8",
      threads: "16",
      baseFrequency: "4.7 GHz",
      boostFrequency: "5.2 GHz",
      cache: "96MB",
      socket: "AM5",
      memoryType: "DDR5",
      stockCooler: "No"
    },
    imageUrl: ""
  },
  {
      id: "cpu-11",
      name: "AMD Ryzen 7 9700X",
      brand: "AMD",
      price: 325,
      amazonLink: "https://amzn.to/4cT2gDk",
      specs: {
        cores: "8",
        threads: "16",
        baseFrequency: "4.5 GHz",
        boostFrequency: "5.7 GHz",
        cache: "96MB",
        socket: "AM5",
        memoryType: "DDR5",
        stockCooler: "No"
      },
      imageUrl: ""
    },
    {
      id: "cpu-12",
      name: "AMD Ryzen 9 9900X3D",
      brand: "AMD",
      price: 625,
      amazonLink: "https://amzn.to/4cT2gDk",
      specs: {
        cores: "16",
        threads: "32",
        baseFrequency: "4.5 GHz",
        boostFrequency: "5.7 GHz",
        cache: "128MB",
        socket: "AM5",
        memoryType: "DDR5",
        stockCooler: "No"
      },
      imageUrl: ""
    },
    {
      id: "cpu-13",
      name: "i9-14900K",
      brand: "Intel",
      price: 625,
      amazonLink: "https://amzn.to/4cT2gDk",
      specs: {
        cores: "24",
        threads: "32",
        baseFrequency: "4.5 GHz",
        boostFrequency: "5.7 GHz",
        cache: "24MB",
        socket: "LGA 1700",
        memoryType: "DDR5",
        stockCooler: "No"
      },
      imageUrl: ""
    },
    {
      id: "cpu-14",
      name: "i5-14400F",
      brand: "Intel",
      price: 150,
      amazonLink: "https://amzn.to/4cT2gDk",
      specs: {
        cores: "6",
        threads: "12",
        baseFrequency: "4.0 GHz",
        boostFrequency: "5.0 GHz",
        cache: "18MB",
        socket: "LGA 1700",
        memoryType: "DDR5",
        stockCooler: "No"
      },
      imageUrl: ""
    }
];

export const cpuComponents: ComponentCategory = {
  id: "cpu",
  name: "Processor (CPU)",
  description: "The brain of your PC that handles all the instructions and calculations.",
  required: true,
  options: baseCpus.map(cpu => ({
    ...cpu,
    socketType: 'CPU_SOCKET',
    modelPath: '/models/cpu.glb', // Generic CPU model
    scale: [0.05, 0.02, 0.05], // Placeholder scale for a CPU
  })),
};

export const cpuData = baseCpus;
